import { StoryblokComponent } from '@storyblok/react'
import { useTranslation } from 'next-i18next'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { useTiersSectionAtom } from '@/features/priceCalculator/PurchaseFormV2/priceCalculatorAtoms'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { ProductTierSelectorV2 } from './OfferPresenterV2/ProductTierSelectorV2/ProductTierSelectorV2'
import { SectionSubtitle } from './SectionHeading'
import { SectionTitle } from './SectionHeading'

export function TiersSection({
  tiers,
  selectedTier,
  onTierChange,
}: {
  tiers: Array<ProductOfferFragment>
  selectedTier: ProductOfferFragment
  onTierChange: (offerId: string) => void
}) {
  const { t } = useTranslation('purchase-form')
  const tiersSectionContent = useTiersSectionAtom()

  return (
    <section>
      {tiersSectionContent.length > 0 ? (
        tiersSectionContent.map((blok) => <StoryblokComponent key={blok._uid} blok={blok} nested={true} />)
      ) : (
        <>
          <SectionTitle>{t('OFFER_PRESENTER_TIERS_TITLE')}</SectionTitle>
          <SectionSubtitle className={sprinkles({ marginBottom: 'lg' })}>
            {t('OFFER_PRESENTER_TIERS_SUBTITLE')}
          </SectionSubtitle>
        </>
      )}
      <div className={yStack({ alignItems: 'stretch', gap: 'md' })}>
        <ProductTierSelectorV2 offers={tiers} selectedOffer={selectedTier} onValueChange={onTierChange} />
      </div>
    </section>
  )
}
